module.exports = __webpack_public_path__ + "static/media/ic-arrow-back.dfd01257.svg";